class MqcHeroShowcase extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-hero-item]'));
    this.dotsWrap = this.querySelector('[data-hero-dots]');
    this.stage = this.querySelector('[data-hero-stage]');
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.index = 0;
    this.timer = null;

    if (this.items.length) {
      this.items[0].classList.add('is-active');
    }

    if (this.items.length > 1) {
      this._buildDots();
      this._play();
    }

    if (this.stage && !this.reduceMotion && window.matchMedia('(pointer: fine)').matches) {
      this._bindTilt();
    }
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }

  _buildDots() {
    if (!this.dotsWrap) return;
    this.dots = this.items.map((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mqc-hero-showcase__dot';
      dot.setAttribute('aria-label', 'Ver producto ' + (i + 1));
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => this._goTo(i, true));
      this.dotsWrap.appendChild(dot);
      return dot;
    });
  }

  _play() {
    const seconds = parseFloat(this.dataset.autoplay || '5');
    const ms = (isNaN(seconds) ? 5 : seconds) * 1000;
    this.timer = setInterval(() => this._goTo((this.index + 1) % this.items.length), ms);
  }

  _goTo(next, manual) {
    if (next === this.index) return;
    const current = this.items[this.index];
    const upcoming = this.items[next];

    current.classList.remove('is-active');
    current.classList.add('is-leaving');
    upcoming.classList.add('is-active');

    setTimeout(() => current.classList.remove('is-leaving'), 800);

    if (this.dots) {
      this.dots[this.index].classList.remove('is-active');
      this.dots[next].classList.add('is-active');
    }

    this.index = next;

    if (manual && this.timer) {
      clearInterval(this.timer);
      this._play();
    }
  }

  _bindTilt() {
    let raf = null;
    this.stage.addEventListener('pointermove', (e) => {
      const rect = this.stage.getBoundingClientRect();
      const px = (e.clientX - rect.left) / rect.width - 0.5;
      const py = (e.clientY - rect.top) / rect.height - 0.5;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        this.stage.style.setProperty('--tilt-x', (py * -6).toFixed(2) + 'deg');
        this.stage.style.setProperty('--tilt-y', (px * 6).toFixed(2) + 'deg');
        this.stage.style.setProperty('--shift-x', (px * 8).toFixed(2) + 'px');
        this.stage.style.setProperty('--shift-y', (py * 8).toFixed(2) + 'px');
      });
    });
    this.stage.addEventListener('pointerleave', () => {
      this.stage.style.setProperty('--tilt-x', '0deg');
      this.stage.style.setProperty('--tilt-y', '0deg');
      this.stage.style.setProperty('--shift-x', '0px');
      this.stage.style.setProperty('--shift-y', '0px');
    });
  }
}

customElements.define('mqc-hero-showcase', MqcHeroShowcase);
